'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require('redux');

var _reactRouterRedux = require('react-router-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _reduxForm = require('redux-form');

var _appInfo = require('./appInfo');

var _appInfo2 = _interopRequireDefault(_appInfo);

var _auth = require('./auth');

var _auth2 = _interopRequireDefault(_auth);

var _captcha = require('./captcha');

var _captcha2 = _interopRequireDefault(_captcha);

var _log = require('./log');

var _log2 = _interopRequireDefault(_log);

var _popup = require('./popup');

var _popup2 = _interopRequireDefault(_popup);

var _features = require('./features');

var _features2 = _interopRequireDefault(_features);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  routing: _reactRouterRedux.routerReducer,
  reduxAsyncConnect: _reduxAsyncConnect.reducer,
  appInfo: _appInfo2.default,
  auth: _auth2.default,
  captcha: _captcha2.default,
  form: _reduxForm.reducer,
  log: _log2.default,
  popup: _popup2.default,
  features: _features2.default
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/reducer.js
// module id = 2040
// module chunks = 0